import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotkeysComponent } from './hotkeys.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { HotkeyRowComponent } from './hotkey-row/hotkey-row.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CommonModule
  ],
  declarations: [
    HotkeysComponent,
    HotkeyRowComponent
  ]
})
export class HotkeyCheatsModule { }
